import { useTranslation } from 'react-i18next';
import { Button, Modal, ModalActions, ModalContent, ModalTitleInfo } from '@c2fo/liquidity';
import percentagerotateSvg from '@/shared/assets/percentagerotate.svg?url';

interface CashFlowCalculationModalProps {
  open: boolean;
  onClose: () => void;
}

const CashFlowCalculationModal = ({ open, onClose }: CashFlowCalculationModalProps) => {
  const { t } = useTranslation();

  const FORMULAS = [
    {
      title: t('instantPay.calculationModal.formula.instantPayBenefitTitle'),
      formula: t('instantPay.calculationModal.formula.instantPayBenefitFormula'),
    },
    {
      title: t('instantPay.calculationModal.formula.dsoImprovementTitle'),
      formula: t('instantPay.calculationModal.formula.dsoImprovementFormula'),
    },
    {
      title: t('instantPay.calculationModal.formula.annualizedTitle'),
      formula: t('instantPay.calculationModal.formula.annualizedFormula'),
      note: t('instantPay.calculationModal.formula.annualizedNote'),
    },
  ];

  return (
    <Modal open={open} onClose={onClose} size="sm">
      <ModalTitleInfo>{t('instantPay.calculationModal.title')}</ModalTitleInfo>
      <ModalContent center>
        <img src={percentagerotateSvg} alt="" className="size-20" />
        <p className="text-left">{t('instantPay.calculationModal.description')}</p>
        <div className="mt-2 w-full space-y-6 text-left">
          {FORMULAS.map(({ title, formula, note }) => (
            <div key={title} className="rounded border border-stroke p-4">
              <div className="font-bold">{title}</div>
              <div className="mt-2 rounded bg-canvas p-2">{formula}</div>
              {note && <div className="mt-2 text-xs italic text-text-secondary">{note}</div>}
            </div>
          ))}
        </div>
      </ModalContent>
      <ModalActions>
        <Button variant="secondary" onClick={onClose}>
          {t('instantPay.calculationModal.closeButton')}
        </Button>
      </ModalActions>
    </Modal>
  );
};

export default CashFlowCalculationModal;
